module.exports = __webpack_public_path__ + "static/media/wj.b4728925.svg";